import Vue from 'vue'
import Router from 'vue-router'
import HomeComponent from '@/components/Home/Home'
import ProvidersComponent from '@/components/Providers/Providers'
import ADTProvidersComponent from '@/components/Providers/Adt/Adt'
import ReviewsComponent from '@/components/Reviews/Reviews'
import ADTReviewsComponent from '@/components/Reviews/Adt/Adt'
import FAQComponent from '@/components/FAQ/FAQ'
import CompareComponent from '@/components/Compare/Compare'
import PrivacyComponent from '@/components/Privacy/Privacy'

Vue.use(Router)

var router = new Router({
  mode: "history",
  
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeComponent
    },
    {
      path: '/providers',
      name: 'Providers',
      component: ProvidersComponent
    },
    {
      path: '/providers/:provider',
      name: 'ADT-Providers',
      component: ADTProvidersComponent
    },
    {
      path: '/reviews',
      name: 'Reviews',
      component: ReviewsComponent
    },
    {
      path: '/reviews/:provider',
      name: 'ADT-Reviews',
      component: ADTReviewsComponent
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQComponent
    },
    {
      path: '/compare',
      name: 'Compare',
      component: CompareComponent
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: PrivacyComponent
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(function(to, from, next) {
  window.scroll(0,0);
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js